import { createSelector } from 'reselect';
import mapValues from 'lodash/mapValues';
import { userSelector } from 'redux/modules/user';

export const addressesSelector = createSelector(userSelector, user =>
  mapValues(user.addresses, (v, k) => ({ ...v, id: k })),
);
